import { SafeUrl } from '@angular/platform-browser';
export interface FileHandle {
  file: File;
  url: SafeUrl;
}

export enum MalwareScanningStatus {
  Unscanned = 'UNSCANNED',
  Clean = 'CLEAN',
  Quarantined = 'QUARANTINED',
}
